@if (isLink(item) && !isFunction(item.route)) {
	@if (item.route === '/ticketManagement') {
		<a
			(click)="clearTicketManagementSession(item)"
			class="vex-sidenav-item"
			matRipple
			matRippleColor="var(--sidenav-item-ripple-color)"
			routerLinkActive="vex-sidenav-item--active">
			@if (level() === 0 || level() === 1) {
				<mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
			}
			@if (item.img) {
				<img [src]="item.img" class="vex-sidenav-item__img" alt="{{ item.label }}" />
			} @else {
				<span class="vex-sidenav-item__label">{{ item.label }}</span>
			}
			@if (item.badge) {
				<span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
			}
		</a>
	} @else {
		<a
			[fragment]="item.fragment"
			[routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
			[routerLink]="item.route"
			class="vex-sidenav-item"
			matRipple
			matRippleColor="var(--sidenav-item-ripple-color)"
			routerLinkActive="vex-sidenav-item--active">
			@if (level() === 0 || level() === 1) {
				<mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
			}
			@if (item.img) {
				<img [src]="item.img" class="vex-sidenav-item__img" alt="{{ item.label }}" />
			} @else {
				<span #labelEl class="vex-sidenav-item__label" [matTooltip]="item.label" [matTooltipDisabled]="labelEl.scrollWidth <= labelEl.clientWidth">
					{{ item.label }}
				</span>
			}
			@if (item.badge) {
				<span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
			}
			@if (item.soon) {
				<ara-soon-badge [height]="16"></ara-soon-badge>
			}
		</a>
	}
}

@if (isLink(item) && isFunction(item.route)) {
	<div (click)="item.route()" class="vex-sidenav-item" matRipple matRippleColor="var(--sidenav-item-ripple-color)">
		@if (level() === 0 || level() === 1) {
			<mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
		}
		<span #labelEl class="vex-sidenav-item__label" [matTooltip]="item.label" [matTooltipDisabled]="labelEl.scrollWidth <= labelEl.clientWidth">
			{{ item.label }}
		</span>
		@if (item.badge) {
			<span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
		}
		@if (item.soon) {
			<ara-soon-badge [height]="16"></ara-soon-badge>
		}
	</div>
}
@if (isDropdown(item)) {
	<ng-container>
		<div
			(click)="toggleOpen()"
			[class.vex-sidenav-item--active]="isActive()"
			[class.vex-sidenav-item--open]="isOpen()"
			[class.vex-sidenav-item--highlighted]="isHighlighted()"
			class="vex-sidenav-item dropdown-level-{{ level() }}"
			matRipple
			matRippleColor="var(--sidenav-item-ripple-color)">
			@if (level() === 1) {
				<mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
			}
			@if (item.img) {
				<img [src]="item.img" class="vex-sidenav-item__img" alt="{{ item.label }}" />
			} @else {
				<span class="vex-sidenav-item__label">{{ item.label }}</span>
			}
			@if (item.badge) {
				<span [ngClass]="[item.badge.bgClass, item.badge.textClass]" class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
			}
			@if (item.soon) {
				<ara-soon-badge [height]="16"></ara-soon-badge>
			}
			<mat-icon
				class="vex-sidenav-item__dropdown-icon"
				[class.vex-sidenav-item--highlighted]="isHighlighted()"
				svgIcon="mat:keyboard_arrow_right"></mat-icon>
		</div>
		<div [@dropdown]="isOpen()" class="vex-sidenav-item__dropdown">
			@for (subItem of item.children; track trackByRoute($index, subItem)) {
				<vex-sidenav-item [item]="subItem" [level]="level() + 1"></vex-sidenav-item>
			}
		</div>
	</ng-container>
}

@if (isSubheading(item)) {
	<ng-container>
		<div class="vex-sidenav-subheading">{{ item.label }}</div>
		@for (subItem of item.children; track trackByRoute($index, subItem)) {
			<vex-sidenav-item [item]="subItem" [level]="0"></vex-sidenav-item>
		}
	</ng-container>
}
